const stateCityConstants = {
	FETCH_STATECITY_REQUEST: 'FETCH_STATECITY_REQUEST',
	FETCH_STATECITY_SUCCESS: 'FETCH_STATECITY_SUCCESS',
	FETCH_STATECITY_FAILURE: 'FETCH_STATECITY_FAILURE',
};

export default stateCityConstants;
